/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-15 16:48:45
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { DATA_GUIDE_V2 } from 'src/constants/dashboard-layout-v3';

/**
 * Return guides that match with feature that customer chosen on KYC screen
 * Ex: KYC chose PRODUCT_FILTER, PRODUCT_SEARCH
 * -> Guide with have: V2_FILTER1, V2_FILTER2, V2_FILTER3, V2_SEARCH1, V2_SEARCH2
 * @param {*} steps
 * @returns
 */
export const getAllGuideVisibleByFeature = steps => {
  // 'V2_FILTER1', 'V2_FILTER2', 'V2_FILTER3', 'V2_FILTER4_ADVANCED', ...
  const stepNames = steps.filter(step => step.name?.includes('V2')).map(step => step.name);
  let result = _.cloneDeep(DATA_GUIDE_V2);

  if (!stepNames.includes('V2_FILTER1')) {
    result = result.filter(guide => guide.keyGuide !== 'V2_FILTER');
  }

  if (!stepNames.includes('V2_SEARCH1')) {
    result = result.filter(guide => guide.keyGuide !== 'V2_SEARCH');
  }

  // V2_RECOMMEND1 always avai paid, trial, not freemium
  if (!stepNames.includes('V2_RECOMMEND2')) {
    result = result.filter(guide => guide.keyGuide !== 'V2_RECOMMEND');
  }

  result.forEach(featureGuide => {
    if (_.has(featureGuide, 'children')) {
      const children = featureGuide.children.filter(step => stepNames.includes(step.keyStep));
      featureGuide.children = children;
    }
    if (_.has(featureGuide, 'childrenAdvanced')) {
      const childrenAdvanced = featureGuide.childrenAdvanced.filter(step =>
        stepNames.includes(step.keyStep)
      );
      featureGuide.childrenAdvanced = childrenAdvanced;
    }
  });

  return result;
};

/**
 * Return list guide step visible with the featue
 * @param {*} allGuideVisibleByFeature
 * @returns
 */
export const getAllStepVisibleByFeature = allGuideVisibleByFeature => {
  return allGuideVisibleByFeature.reduce((result, guide) => {
    return [...result, ...guide.children.map(item => item.keyStep)];
  }, []);
};

/**
 * Check the guide that open as default
 * Ex: Priority Filter (1), Search (2)
 * When Filter guide is all done, the guide for search will open
 * @param {*} passedSteps
 * @param {*} allGuideVisibleByFeature
 * @returns
 */
export const findGuideOpening = (passedSteps, allGuideVisibleByFeature, shop, isFreemium) => {
  let isSearchAdvancedClicked;
  try {
    isSearchAdvancedClicked = localStorage.getItem(`${shop}-guide-search-advanced-clicked`);
  } catch (error) {}

  const allGuideName = allGuideVisibleByFeature.map(guide => guide.keyGuide);
  let indexOpening = 0;

  const guideWithStep = {
    V2_FILTER: 3,
    V2_SEARCH: 2,
    V2_RECOMMEND: 2,
    V2_PREVIEW: 1
  };

  // Check freemium plan has 1 guide on recommended
  if (isFreemium) {
    guideWithStep.V2_RECOMMEND = 1;
  }

  for (let index = 0; index < allGuideVisibleByFeature.length; index++) {
    const item = allGuideVisibleByFeature[index];
    const { children, keyGuide } = item;
    const countPassed = children.filter(child => passedSteps.includes(child.keyStep)).length;

    if (
      keyGuide === 'V2_FILTER' &&
      countPassed === 3 &&
      passedSteps.filter(i => i.includes('FILTER') && i.includes('ADVANCED')).length <= 1
    ) {
      indexOpening = index;
      break;
    }

    // Due to search advanced not have item in check list, check by this value isSearchAdvancedClicked
    if (keyGuide === 'V2_SEARCH' && countPassed === 2 && !isSearchAdvancedClicked) {
      indexOpening = index;
      break;
    }

    if (guideWithStep[keyGuide] !== countPassed) {
      indexOpening = index;
      break;
    }

    if (guideWithStep[keyGuide] === countPassed) {
      indexOpening = index + 1;
    }
  }

  // All guide is done
  if (indexOpening === 'DONE') return indexOpening;

  const guideOpen = allGuideName[indexOpening];

  return guideOpen;
};

/**
 * Mapping for old guide for the new guide for old customer
 * @param {*} old
 * @returns
 */
export const newKeyFromOldKeyGuide = old => {
  const MAPPING_OLD_GUIDE_TO_NEW = {
    Filter1: '',
    Filter2: 'V2_FILTER1',
    Filter3: 'V2_FILTER3',
    Filter4: 'V2_FILTER2',
    Search1: '',
    Search2: 'V2_SEARCH1',
    Search3: 'V2_SEARCH1',
    Search4: 'V2_SEARCH1',
    Merchandising1: '',
    Merchandising2: 'V2_SEARCH2',
    Recommendation1: '',
    Recommendation2: 'V2_RECOMMEND1',
    Recommendation3: ''
  };
  return MAPPING_OLD_GUIDE_TO_NEW[old];
};
